/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portalframe_StoreInputs */

const en_portalframe_store = /** @type {(inputs: Portalframe_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Store`)
};

/** @type {(inputs: Portalframe_StoreInputs) => LocalizedString} */
const ar_portalframe_store = en_portalframe_store;

/** @type {(inputs: Portalframe_StoreInputs) => LocalizedString} */
const he_portalframe_store = en_portalframe_store;

/** @type {(inputs: Portalframe_StoreInputs) => LocalizedString} */
const ur_portalframe_store = en_portalframe_store;

/** @type {(inputs: Portalframe_StoreInputs) => LocalizedString} */
const es_portalframe_store = en_portalframe_store;

/** @type {(inputs: Portalframe_StoreInputs) => LocalizedString} */
const fr_portalframe_store = en_portalframe_store;

/** @type {(inputs: Portalframe_StoreInputs) => LocalizedString} */
const de_portalframe_store = en_portalframe_store;

/** @type {(inputs: Portalframe_StoreInputs) => LocalizedString} */
const pt_portalframe_store = en_portalframe_store;

/** @type {(inputs: Portalframe_StoreInputs) => LocalizedString} */
const hi_portalframe_store = en_portalframe_store;

/** @type {(inputs: Portalframe_StoreInputs) => LocalizedString} */
const bn_portalframe_store = en_portalframe_store;

/**
* | output |
* | --- |
* | "Store" |
*
* @param {Portalframe_StoreInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const portalframe_store = /** @type {((inputs?: Portalframe_StoreInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portalframe_StoreInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_portalframe_store(inputs)
	if (locale === "he") return he_portalframe_store(inputs)
	if (locale === "ur") return ur_portalframe_store(inputs)
	if (locale === "es") return es_portalframe_store(inputs)
	if (locale === "fr") return fr_portalframe_store(inputs)
	if (locale === "de") return de_portalframe_store(inputs)
	if (locale === "pt") return pt_portalframe_store(inputs)
	if (locale === "hi") return hi_portalframe_store(inputs)
	if (locale === "bn") return bn_portalframe_store(inputs)
	return /** @type {LocalizedString} */ ("Store")
});